import { render, staticRenderFns } from "./AccommodationForm.vue?vue&type=template&id=733024b4&"
import script from "./AccommodationForm.vue?vue&type=script&lang=js&"
export * from "./AccommodationForm.vue?vue&type=script&lang=js&"
import style0 from "./AccommodationForm.vue?vue&type=style&index=0&id=733024b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports